export const HeroJiraCTA = () => {
    return (
        <section id="hero-jira-cta">
            <h2>The new Jira: from teams to dreams</h2>
            <hr />
        </section>
    );
};
